import {
  IonBackButton,
  IonButton,
  IonButtons,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardSubtitle,
  IonCardTitle,
  IonCol,
  IonContent,
  IonGrid,
  IonHeader,
  IonIcon,
  IonLabel,
  IonList,
  IonListHeader,
  IonLoading,
  IonMenuButton,
  IonModal,
  IonPage,
  IonRefresher,
  IonRefresherContent,
  IonRow,
  IonSkeletonText,
  IonTitle,
  IonToolbar,
  RefresherEventDetail,
  useIonLoading,
  useIonViewDidEnter,
  IonInfiniteScroll,
  IonInfiniteScrollContent,
  IonFooter,
  IonItem,
  IonSpinner,
} from "@ionic/react";
import { useHistory, useLocation, useParams } from "react-router";

import plnSymbol from "../../../assets/img/logo/pln_symbol.svg";
import Navbar from "../../../components/WebApp/Navbar/Navbar";
import PubSub from "../../../lib/PubSub";
import onboardPLNPlus from "../../../assets/img/icons/onboard_plnplus.svg";
import { useEffect, useMemo, useRef, useState } from "react";
import {
  calendar,
  calendarClearOutline,
  cashOutline,
  checkmarkCircle,
  checkmarkCircleOutline,
  chevronForward,
  closeOutline,
  copyOutline,
  create,
  createOutline,
  ellipsisVertical,
  pencil,
  pencilSharp,
  pricetag,
  pricetags,
  settings,
  share,
  shareOutline,
} from "ionicons/icons";

import consultImage from "../../../assets/img/brand/consultation.jpg";
import referralImage from "../../../assets/img/brand/give20get20.jpg";
import StorageUtils from "../../../lib/StorageUtils";
import API from "../../../lib/API";
import StringUtils from "../../../lib/StringUtils";
import moment from "moment";
import Constants from "../../../lib/Constants";
import Event from "../../../lib/Event";
import InlineSchedulingModal from "../../../components/Scheduler/SchedulingCalendar/InlineSchedulingModal";
import InlineReschedulingModal from "../../../components/Scheduler/SchedulingCalendar/InlineReschedulingModal";
import AppointmentInformation from "../../../components/Scheduler/AppointmentInformation/AppointmentInformation";
import DateUtils from "../../../lib/DateUtils";
import UpcomingOrderCard from "../../../components/AccountManagement/UpcomingOrderCard/UpcomingOrderCard";
import ReviewOrderCard from "../../../components/AccountManagement/ReviewOrderCard/ReviewOrderCard";
import _ from "underscore";
import MealDetailContent from "../../../components/MealDetailContent";
import SEOHeaders from "../../../components/SEOHeaders";
import { Capacitor } from "@capacitor/core";
import LinkUtils from "../../../lib/LinkUtils";
import OneSignal from "onesignal-cordova-plugin";
import { PushNotifications } from "@capacitor/push-notifications";
import BillingAddressForm from "../../../components/BillingAddressForm";

const PLNPlusMemberGoalsPage: React.FC<{
  nativeMode?: boolean;
  showBackButton?: boolean;
  next: () => void;
  previous: () => void;
  hasNext: boolean;
  hasPrevious: boolean;
  step: any;
}> = ({
  nativeMode = false,
  showBackButton = false,
  next,
  previous,
  hasNext,
  hasPrevious,
  step,
}) => {
  const history = useHistory();
  const [loading, setLoading] = useState(
    Capacitor?.isNativePlatform() ? true : false,
  );
  const pageRef = useRef();

  const [user, setUser] = useState<any>(null);
  const [newUserName, setNewUserName] = useState<any>(null);
  const [newUserEmail, setNewUserEmail] = useState<any>(null);
  const [newUserPhone, setNewUserPhone] = useState<any>(null);
  const [newUserPhoneReadable, setNewUserPhoneReadable] = useState<any>(null);
  const [newUserShippingAddress, setNewUserShippingAddress] =
    useState<any>(null);
  const [newUserBillingAddress, setNewUserBillingAddress] = useState<any>(null);
  const [newMemberGoals, setNewMemberGoals] = useState<any>([]);
  const [submitting, setSubmitting] = useState(false);

  useIonViewDidEnter(() => {
    PubSub.publish("mobileScreenChange");

    StorageUtils.get("user_customer").then((user) => {
      setUser(user);

      // Set the name email and phone from user information
      let phone = StringUtils.formatPhoneNumberWhileTyping(user?.phone);

      setNewUserEmail(user?.email?.toLowerCase());
      setNewUserPhone(phone?.value?.split(" ").join(""));
      setNewUserPhoneReadable(phone?.formatted);
      setNewUserName(user?.name);

      if (user?.shippingAddress) {
        setNewUserShippingAddress(user?.shippingAddress);
      }
    });
  }, []);

  const updateNewMemberGoals = () => {
    setSubmitting(true);

    API.setUserParameter("goals", newMemberGoals)
      .then(
        (res: any) => {
          next();
        },
        (e) => {},
      )
      .finally(() => {
        setSubmitting(false);
      });
  };

  return (
    <IonPage ref={pageRef}>
      {nativeMode ? (
        <>
          <IonHeader>
            <IonToolbar className="pln-native-toolbar">
              {hasPrevious ? (
                <IonButtons slot="start">
                  <IonBackButton></IonBackButton>
                </IonButtons>
              ) : null}
              <IonTitle>Goals</IonTitle>
            </IonToolbar>
          </IonHeader>
        </>
      ) : (
        <Navbar
          showBackButton={hasPrevious}
          actionButton={<></>}
          showMenuButton={false}
          pageName={"Goals"}
          onGoBack={() => {
            history.goBack();
          }}
        ></Navbar>
      )}

      <IonContent className="bg-white">
        <div className="ion-padding pln-onboarding-container">
          <div className="text-center">
            <h2 className="font-medium font-[SourceSerif] text-2xl mb-[0.25rem]">
              What Are Your Goals?
            </h2>
            <p className="" style={{ fontSize: 18 }}>
              Select up to 3 goals. We'll use these to tailor your app &
              in-store experience!
            </p>
            <div className="mt-[1.5rem] mb-[1.5rem] border-t-[1px] border-gray-100"></div>
            <div className="flex gap-x-4 gap-y-4 grid grid-cols-2">
              {Constants.NEW_MEMBER_GOAL_OPTIONS.map(
                (goal: any, index: number) => {
                  return (
                    <div
                      key={goal?.name}
                      onClick={() => {
                        let goals = newMemberGoals;

                        if (goals?.includes(goal?.name)) {
                          goals = _.without(goals, goal?.name);
                        } else {
                          if (
                            goals?.length >= 3 &&
                            goal?.name != "None Of These Apply"
                          ) {
                            return;
                          }

                          goals.push(goal?.name);
                        }

                        if (goal?.name == "None Of These Apply") {
                          goals = ["None Of These Apply"];
                        } else {
                          goals = _.without(goals, "None Of These Apply");
                        }

                        //console.log(goals);

                        setNewMemberGoals(JSON.parse(JSON.stringify(goals)));
                      }}
                      className={`rounded border-[2px] ${
                        newMemberGoals?.includes(goal?.name)
                          ? "border-orange-500 bg-orange-25"
                          : "border-gray-100"
                      } p-[1rem] text-center cursor-pointer flex items-center transition-all`}
                    >
                      <div className="w-full">
                        <div
                          className={`text-center transition-all ${
                            newMemberGoals?.includes(goal?.name)
                              ? "text-orange-500"
                              : "text-gray-900"
                          }`}
                          dangerouslySetInnerHTML={{ __html: goal?.icon }}
                        />

                        <p className="text-gray-900 text-sm sm:text-base leading-4 mt-[0.25rem]">
                          {goal?.name}
                        </p>
                      </div>
                    </div>
                  );
                },
              )}
            </div>
          </div>
        </div>
      </IonContent>
      <IonFooter>
        <IonToolbar
          className={`pln-native-toolbar-footer ${
            !Capacitor.isNativePlatform() ? "web" : ""
          }`}
        >
          <IonButton
            disabled={newMemberGoals?.length == 0 || submitting}
            onClick={() => {
              next();
            }}
            expand="block"
            mode={
              Capacitor.isNativePlatform()
                ? Capacitor.getPlatform() == "ios"
                  ? "ios"
                  : "md"
                : "ios"
            }
          >
            {submitting ? <IonSpinner name="dots" /> : "Continue"}
          </IonButton>
        </IonToolbar>
      </IonFooter>
    </IonPage>
  );
};

export default PLNPlusMemberGoalsPage;
